(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["crossx-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
  const link=event.target.closest('.cx-nav-mobile a');
  if(link)link.closest('details').open=false;
});
  } catch(e) { console.error(e); }
})();

})();
